import { render, staticRenderFns } from "./CustomCard.vue?vue&type=template&id=5db96073&scoped=true&"
import script from "./CustomCard.vue?vue&type=script&lang=js&"
export * from "./CustomCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomCard.vue?vue&type=style&index=0&id=5db96073&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db96073",
  null
  
)

export default component.exports